import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "bs-table-actions",
  ref: "container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "12",
    r: "1"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_icon_button = _resolveComponent("bs-icon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_bs_icon_button, {
      ref: "reference",
      size: "small",
      color: "white",
      onClick: _ctx.open
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_Transition, { name: "m-tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "bs-m-tooltip bs-table-actions__tooltip",
              ref: "tooltip",
              style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` })
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}